/**
 * Hits Component
 */
import React, { Component } from 'react'
import { Carousel } from 'react-responsive-carousel'
import { LazyLoadImage } from 'react-lazy-load-image-component'
import PropTypes from 'prop-types'
import { sendGenericEvent } from '../../../common/GoogleTagManager'
import constants from '../../../common/constants'
import AttributeTag from '../../../functional-components/Tags/components/AttributeTag'
import CampaignTag from '../../../functional-components/Tags/components/CampaignTag'
import './imagesCarousel.css'

import ImageWrapper from './ImageWrapper'
import { setURLParams, getImageSizeAndFormatParams } from '../../../Helpers/imageHelper.js'

class MobileImagePreview extends Component {
  constructor(props) {
    super(props)
    this.state = {
      imageToShow: 0,
      backgroundImage: '',
      imageExists: true,
    }
  }

  componentDidUpdate(prevProps) {
    const { images } = this.props
    const { images: prevImages } = prevProps

    if (prevProps && prevImages && JSON.stringify(prevImages) !== JSON.stringify(images)) {
      this.getImageToShow()
    }
  }

  componentDidMount = () => {
    this.getImageToShow()
  }

  getImageToShow = () => {
    const {
      hit: { sku },
      images,
    } = this.props
    const { imageToShow } = this.state
    if (images[imageToShow]) {
      this.setState({
        backgroundImage: images[imageToShow],
        imageExists: true,
      })
      return
    }

    this.setState({
      backgroundImage: constants.PRODUCT_WITHOUT_IMAGE,
      imageExists: false,
    })
    sendGenericEvent('product-with-no-photo', { sku })
  }

  renderCarousel = (isAvailable) => {
    const { images, hit } = this.props

    const renderCustomThumbs = () => {
      const thumbList = images.map((url, index) => {
        return (
          <div key={`thumb-${index}`}>
            <ImageWrapper url={url}>
              <LazyLoadImage alt={`thumb-${index}`} src={url} fetchpriority="low" />
            </ImageWrapper>
          </div>
        )
      })

      return thumbList
    }

    const renderImageOnView = (carouselElement) => {
      const {
        props: { url },
      } = carouselElement.props.children
      const imgParams = getImageSizeAndFormatParams(url, 2000)
      const imgUrl = setURLParams(url, imgParams)
      const elementWithFormatedImage = {
        ...carouselElement,
        props: {
          ...carouselElement.props,
          children: {
            ...carouselElement.props.children,
            props: {
              ...carouselElement.props.children.props,
              url: imgUrl,
            },
          },
        },
      }
      return elementWithFormatedImage
    }

    const carouselImages = images.length ? images : [`${window.location.origin}${constants.PRODUCT_WITHOUT_IMAGE}`]

    return (
      <Carousel
        showThumbs
        autoPlay={false}
        interval={3000}
        infiniteLoop
        showStatus={false}
        showArrows
        showIndicators={false}
        renderItem={renderImageOnView}
        renderThumbs={renderCustomThumbs}
      >
        {carouselImages.map((imageUrl, ix) => (
          <div key={`product-${ix}`} className={'carousel-image-wrapper'}>
            <ImageWrapper url={imageUrl}>
              <LazyLoadImage
                alt={`${hit.brand} - ${hit.displayName}`}
                src={imageUrl}
                className={`img-fluid ${!isAvailable ? 'carousel__galery-img--opaque' : ''}`}
                fetchpriority="high"
              />
            </ImageWrapper>
          </div>
        ))}
      </Carousel>
    )
  }

  render() {
    const {
      hit: { tags, available },
      images,
    } = this.props
    const { imageExists } = this.state
    const hasImage = images && imageExists

    return (
      <div className="position-relative mobile-carousel-wrapper">
        <CampaignTag tags={tags} isAvailable={available} classNames="tags__campaign-tag-container--absolute" />
        <AttributeTag
          tags={tags}
          isAvailable={available}
          classNames={`tags__attribute-tag-container--absolute ${
            hasImage ? '' : 'tags__attribute-tag-container--no-photo'
          } `}
        />
        <div className="mb-4" style={{ boxShadow: '1px 1px #d8d8d8' }}>
          {this.renderCarousel(available)}
        </div>
      </div>
    )
  }
}

export default MobileImagePreview

MobileImagePreview.defaultProps = {
  hit: {},
  images: [],
  walmartExclusive: false,
}

MobileImagePreview.propTypes = {
  hit: PropTypes.object,
  images: PropTypes.array,
  walmartExclusive: PropTypes.bool,
}
